import { combineReducers, configureStore } from '@reduxjs/toolkit';
import type { PreloadedState } from '@reduxjs/toolkit';
import { myAlgoApi } from './api/myAlgoApi';

import accountsReducer from './features/accounts/accountsSlice';
import transactionsReducer from './features/transactions/transactionsSlice';
import assetsReducer from './features/assets/assetsSlice';
import appReducer from './features/application/appSlice';
import walletConnectReducer from './features/walletConnect/walletConnectSlice';

const rootReducer = combineReducers({
  [myAlgoApi.reducerPath]: myAlgoApi.reducer,
  accounts: accountsReducer,
  transactions: transactionsReducer,
  assets: assetsReducer,
  app: appReducer,
  walletConnect: walletConnectReducer,
});

export const setupStore = (preloadedState?: PreloadedState<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      // adding the api middleware enables caching, invalidation, polling and other features of `rtk-query`
      getDefaultMiddleware({ serializableCheck: false }).concat(myAlgoApi.middleware),
    preloadedState,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
